[
  {
    "id": "101",
    "label": "Caída de personas a distinto nivel"
  },
  {
    "id": "102",
    "label": "Caída de personas al mismo nivel"
  },
  {
    "id": "103",
    "label": "Caída de objetos por desplome o derrumbamiento"
  },
  {
    "id": "104",
    "label": "Caída de objetos en manipulación"
  },
  {
    "id": "105",
    "label": "Caída de objetos desprendidos"
  },
  {
    "id": "106",
    "label": "Pisadas sobre objetos"
  },
  {
    "id": "107",
    "label": "Choque contra objetos móviles"
  },
  {
    "id": "108",
    "label": "Choque contra objetos inmóviles"
  },
  {
    "id": "109",
    "label": "Golpes o cortes con objetos o herramientas"
  },
  {
    "id": "110",
    "label": "Proyección de fragmentos o partículas"
  },
  {
    "id": "111",
    "label": "Atrapamiento o cortes por o entre equipos"
  },
  {
    "id": "112",
    "label": "Atrapamiento por vuelco de máquinas o vehículos"
  },
  {
    "id": "113",
    "label": "Manipulación manual de cargas"
  },
  {
    "id": "114",
    "label": "Exposición a condiciones ambientales extremas"
  },
  {
    "id": "115",
    "label": "Contactos térmicos"
  },
  {
    "id": "116",
    "label": "Contactos eléctricos"
  },
  {
    "id": "117",
    "label": "Inhalación o ingestión de sustancias nocivas o tóxicas"
  },
  {
    "id": "118",
    "label": "Contactos con sustancias agresivas"
  },
  {
    "id": "119",
    "label": "Contaminación por agentes biológicos"
  },
  {
    "id": "120",
    "label": "Exposición a radiaciones"
  },
  {
    "id": "121",
    "label": "Incendios y explosiones"
  },
  {
    "id": "122",
    "label": "Accidentes causados por seres vivos"
  },
  {
    "id": "123",
    "label": "Atropellos o golpes por vehículos"
  },
  {
    "id": "124",
    "label": "Accidentes por circulación"
  },
  {
    "id": "125",
    "label": "Posturas forzadas"
  },
  {
    "id": "126",
    "label": "Fatiga visual"
  },
  {
    "id": "127",
    "label": "Exposición a vibraciones"
  },
  {
    "id": "128",
    "label": "Movimientos repetitivos"
  },
  {
    "id": "129",
    "label": "Exposición a ruido"
  },
  {
    "id": "135",
    "label": "Psicosociales"
  },
  {
    "id": "140",
    "label": "Trabajos en solitario"
  },
  {
    "id": "LEGAL",
    "label": "INCUMPLIMIENTO LEGAL / SISTEMA"
  }
]
